import { useCallback, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRotateRight } from "@fortawesome/free-solid-svg-icons"
import api from "../../components/utils/api"
import MainTitle from "../../components/template/MainTitle"
import ButtonWrap from "../../components/template/ButtonWrap"
import TrainingComparison from "./TrainingComparison"

// Standalone page comparing an experiment's training runs, opened in a new
// tab from the experiment detail page.
const TrainingComparisonPage = () => {
    const params = useParams()
    const [experiment, setExperiment] = useState(null)
    const [refreshKey, setRefreshKey] = useState(0)

    const fetchExperiment = useCallback(async () => {
        try {
            const res = await api.get(`/api/experiments/${params.id}`)
            setExperiment(res.data)
        } catch (error) {
            console.error(error)
        }
    }, [params])

    useEffect(() => { fetchExperiment() }, [fetchExperiment])

    return (
        <div className="default-background">
            <div className="flex justify-between items-center my-5">
                <MainTitle title={`Run Comparison${experiment ? ` - ${experiment.database_summary.name}_${experiment.version}` : ""}`} />
                <ButtonWrap
                    contents={<FontAwesomeIcon icon={faArrowRotateRight} />}
                    onClick={() => setRefreshKey(key => key + 1)}
                />
            </div>
            <TrainingComparison experimentId={params.id} refreshKey={refreshKey} />
        </div>
    )
}

export default TrainingComparisonPage
